import * as XLSX from "xlsx";

export function toSafeFileName(name: string, maxLength = 50): string {
  return name
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .slice(0, maxLength);
}

// Excel sheet names: max 31 chars, can't contain \ / ? * [ ] : , and can't start/end with an
// apostrophe. book_append_sheet throws on a name that violates these, so any caller passing a
// free-form (e.g. user-authored template) name needs it sanitized first.
export function toSafeSheetName(name: string, maxLength = 31): string {
  const cleaned = name.replace(/[\\/?*[\]:]/g, "").trim().replace(/^'+|'+$/g, "");
  const safe = cleaned.length > 0 ? cleaned : "Sheet1";
  return safe.slice(0, maxLength);
}

export function useExcelExport() {
  const exportToExcel = (
    rows: Record<string, string>[],
    sheetName = "Sheet1",
    fileName = "export.xlsx"
  ) => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, toSafeSheetName(sheetName));
    XLSX.writeFile(wb, fileName);
  };

  return { exportToExcel };
}
